import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT + "/api/x-admin/images-manger";

const addImage = async (data) => {
  return await axios.post(API_ENDPOINT, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const getAllImages = async () => {
  const response = await axios.get(`${API_ENDPOINT}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response;
};
const deleteImage = async (imageName) => {
  const imageNamedel = imageName.substring(imageName.lastIndexOf("/") + 1);
  return await axios.delete(`${API_ENDPOINT}/${imageNamedel}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const imageManagerServices = {
  addImage,
  getAllImages,
  deleteImage,
};

export default imageManagerServices;
